import ISitemapUrl from '@/interfaces/IUrl';
import Provider from '@/enums/Provider';
import determineUrlType from '@/helpers/urlType/determineUrlType';
import UrlFetchStatus from '@/enums/UrlFetchStatus';

/**
 * Builds an ISitemapUrl object from a <url> element.
 */
export function buildSitemapUrl(
    loc: string,
    provider: Provider
): ISitemapUrl {
    return {
        pathname: new URL(loc).pathname,
        lastmod: '',
        changefreq: '',
        priority: '',
        urlType: determineUrlType(loc, provider),
        isSitemap: true,
        fetchStatus: UrlFetchStatus.TO_FETCH,
    };
}